import { AccordionFilterItem } from "../../../accordion/Accordion";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from "../../../select/Select";
import { useContext } from "react";
import {
  PersonFiltersContext,
  PersonFiltersEventContext,
} from "../../../../context/FiltersContext";
import {
  IPersonStatusFilterSetting,
  QueryFilter,
  PersonFilterKeys,
} from "../../../../interfaces/filters";
import { f } from "../../../../util/f";
import { PersonDtoFilterInput } from "../../../../interfaces/schema";

// helpers
const filterKey: QueryFilter<PersonFilterKeys>["filterKey"] = "status";

export default function PersonStatusFilter() {
  // query filter context
  const filters = useContext(PersonFiltersContext);
  const updateFilters = useContext(PersonFiltersEventContext);

  // find the filter settings
  const settings: IPersonStatusFilterSetting = filters.find(
    (f) => f.filterKey === filterKey,
  )?.settings;

  // handler
  function selectEventHandler(value: IPersonStatusFilterSetting["selected"]) {
    if (value === null) {
      updateFilters({
        event: "delete",
        queryFilter: {
          filterKey: filterKey,
        },
      });
      return;
    }

    const queryFilter: QueryFilter<
      PersonFilterKeys,
      IPersonStatusFilterSetting
    > = {
      filterKey: filterKey,
      filter: f<PersonDtoFilterInput>()
        .addFilter("erUdoevende", {
          eq: value,
        })
        .build(),
      parentFilter: "and",
      settings: {
        selected: value,
      },
    };

    updateFilters({
      event: "update",
      queryFilter: queryFilter,
    });
  }

  return (
    <AccordionFilterItem
      title="Status"
      value="status"
      isActive={settings ? (settings?.selected === null ? false : true) : false}
    >
      <Select
        defaultValue={settings ? String(settings?.selected) : "null"}
        value={settings ? String(settings?.selected) : "null"}
        onValueChange={(value: string) => {
          selectEventHandler(JSON.parse(value));
        }}
      >
        <SelectTrigger
          aria-label="Vælg filterfunktion"
          className={`${
            settings
              ? settings?.selected === null
                ? false
                : "filter-is-active"
              : ""
          }`}
        />
        <SelectContent small>
          <SelectItem value={"null"} key={"null"}>
            Alle
          </SelectItem>
          <SelectItem value={"true"} key={"true"}>
            Udøvende
          </SelectItem>
          <SelectItem value={"false"} key={"false"}>
            Ikke udøvende
          </SelectItem>
        </SelectContent>
      </Select>
    </AccordionFilterItem>
  );
}
